import type { Node, Edge } from "@xyflow/react";
import { emptyNodeData, emptyPort, uid } from "./constants";
import type { IdeaNodeData } from "./types";

export function exampleFlow(): { nodes: Node<IdeaNodeData>[]; edges: Edge[] } {
  const ids = [uid(), uid(), uid()];
  const input = emptyPort("input", "input");
  const output = emptyPort("output", "answer");
  return {
    nodes: [
      {
        id: ids[0],
        type: "ideaNode",
        position: { x: 30, y: 160 },
        data: {
          ...emptyNodeData("signal"),
          title: "Nachricht absenden",
          description: "Eine Person schickt eine Frage ab.",
          signal: {
            event: "message.submitted",
            source: "Chat · Senden-Button",
            payload: "Wie plane ich einen fokussierten Arbeitstag?",
          },
        },
      },
      {
        id: ids[1],
        type: "ideaNode",
        position: { x: 350, y: 160 },
        data: {
          ...emptyNodeData("action"),
          title: "Antwort formulieren",
          ports: [input, output],
          actionPayload: {
            subtype: "llm_prompt",
            systemPrompt:
              "Antworte auf Deutsch, hilfreich und in maximal drei Sätzen.",
            userTemplate: "Beantworte diese Frage: {{input}}",
          },
          testInput: "Wie plane ich einen fokussierten Arbeitstag?",
          expectedOutput: "Drei konkrete, umsetzbare Vorschläge.",
        },
      },
      {
        id: ids[2],
        type: "ideaNode",
        position: { x: 670, y: 160 },
        data: {
          ...emptyNodeData("state"),
          title: "Antwort sichtbar",
          state: {
            value: "answered",
            enterWhen: "LLM-Antwort vollständig empfangen",
            exitWhen: "Neue Nachricht wird abgesendet",
          },
        },
      },
    ],
    edges: [
      {
        id: uid(),
        source: ids[0],
        target: ids[1],
        targetHandle: input.id,
        type: "deletable",
      },
      {
        id: uid(),
        source: ids[1],
        target: ids[2],
        sourceHandle: output.id,
        type: "deletable",
      },
    ],
  };
}
